var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.248,
    height: 19.349,
    viewBox: "0 0 32.248 19.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M220.949,110.474a9.674,9.674,0,1,1-19.349,0h0a9.674,9.674,0,1,1,19.349,0Z",
    transform: "translate(-188.701 -100.8)",
    fill: "#ffb600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M211.274,100.8a9.7,9.7,0,0,1,9.674,9.674h0a9.674,9.674,0,1,1-19.349,0",
    transform: "translate(-188.701 -100.8)",
    fill: "#f7981d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M352.8,100.8a9.7,9.7,0,0,1,9.674,9.674h0a9.667,9.667,0,0,1-9.674,9.674",
    transform: "translate(-330.226 -100.8)",
    fill: "#ff8500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M9.572,100.8a9.675,9.675,0,0,0,.1,19.349,9.787,9.787,0,0,0,6.5-2.508h0a9.2,9.2,0,0,0,.973-1.024h-2a11.811,11.811,0,0,1-.717-.973h3.43a6.558,6.558,0,0,0,.563-1.024H13.872a6.1,6.1,0,0,1-.409-1.024h5.323a10.164,10.164,0,0,0,.512-3.071,13.212,13.212,0,0,0-.2-2.047H13.155a7.484,7.484,0,0,1,.256-1.024h5.323a6.1,6.1,0,0,0-.409-1.024h-4.5a10.151,10.151,0,0,1,.563-1.024h3.43a4.868,4.868,0,0,0-.768-1.024H15.151a8.722,8.722,0,0,1,.973-.973,9.445,9.445,0,0,0-6.5-2.508C9.623,100.8,9.623,100.8,9.572,100.8Z",
    transform: "translate(0 -100.8)",
    fill: "#ff5050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M0,111.972a9.667,9.667,0,0,0,9.674,9.674,9.787,9.787,0,0,0,6.5-2.508h0a9.2,9.2,0,0,0,.973-1.024h-2a11.806,11.806,0,0,1-.717-.973h3.43a6.557,6.557,0,0,0,.563-1.024H13.872a6.1,6.1,0,0,1-.409-1.024h5.323a10.164,10.164,0,0,0,.512-3.071,13.213,13.213,0,0,0-.2-2.047H13.155a7.483,7.483,0,0,1,.256-1.024h5.323a6.1,6.1,0,0,0-.409-1.024h-4.5a10.153,10.153,0,0,1,.563-1.024h3.43a4.868,4.868,0,0,0-.768-1.024H15.151a8.726,8.726,0,0,1,.973-.973,9.446,9.446,0,0,0-6.5-2.508H9.572",
    transform: "translate(0 -102.298)",
    fill: "#e52836"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M149.7,121.646a9.787,9.787,0,0,0,6.5-2.508h0a9.2,9.2,0,0,0,.973-1.024h-2a11.808,11.808,0,0,1-.717-.973h3.43a6.557,6.557,0,0,0,.563-1.024H153.9a6.1,6.1,0,0,1-.41-1.024h5.323a10.164,10.164,0,0,0,.512-3.071,13.208,13.208,0,0,0-.2-2.047h-5.938a7.484,7.484,0,0,1,.256-1.024h5.323a6.1,6.1,0,0,0-.41-1.024h-4.5a10.157,10.157,0,0,1,.563-1.024h3.43a4.867,4.867,0,0,0-.768-1.024h-1.894a8.728,8.728,0,0,1,.973-.973,9.445,9.445,0,0,0-6.5-2.508H149.6",
    transform: "translate(-140.028 -102.298)",
    fill: "#cb2026"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0.921 7.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M183.084,224.5l.154-.87a2.219,2.219,0,0,1-.256.051c-.358,0-.41-.2-.358-.307l.307-1.792h.563l.154-.973h-.512l.1-.614h-1.024s-.614,3.378-.614,3.788a.768.768,0,0,0,.819.87A1.571,1.571,0,0,0,183.084,224.5Z",
    transform: "translate(-170.902 -219.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M210.4,231.009a1.628,1.628,0,0,0,1.792,1.792,2.657,2.657,0,0,0,1.075-.154l.2-.973a3.068,3.068,0,0,1-1.075.256c-1.126,0-.921-.819-.921-.819h2.1a6.637,6.637,0,0,0,.154-.921,1.387,1.387,0,0,0-1.484-1.484C211.168,228.6,210.4,229.729,210.4,231.009Zm1.792-1.484c.563,0,.461.665.461.717h-1.126C211.526,230.19,211.628,229.524,212.192,229.524Z",
    transform: "translate(-197.859 -227.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M298.815,217.765l.2-1.126a2.516,2.516,0,0,1-.87.256c-.717,0-1.024-.563-1.024-1.177,0-1.228.614-1.894,1.331-1.894a1.709,1.709,0,0,1,.921.307l.154-1.075a3.6,3.6,0,0,0-1.177-.256c-1.177,0-2.355,1.024-2.355,2.969,0,1.28.614,2.15,1.843,2.15A4.594,4.594,0,0,0,298.815,217.765Z",
    transform: "translate(-277.982 -212.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M88.345,227.2a3.625,3.625,0,0,0-1.228.2l-.154.87a3.025,3.025,0,0,1,1.126-.2c.358,0,.665.051.665.358,0,.2-.051.256-.051.256h-.461c-.87,0-1.843.358-1.843,1.536,0,.921.614,1.126.973,1.126a1.538,1.538,0,0,0,1.075-.461l-.051.41h.921l.41-2.815A1.213,1.213,0,0,0,88.345,227.2Zm.2,2.3c0,.154-.1.973-.717.973a.4.4,0,0,1-.409-.41c0-.256.154-.614.921-.614A.807.807,0,0,0,88.55,229.5Z",
    transform: "translate(-81.793 -226.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M136.377,230.6a1.312,1.312,0,0,0,1.536-1.331c0-1.28-1.228-1.024-1.228-1.536,0-.256.2-.358.563-.358.154,0,.717.051.717.051l.154-.921a3.888,3.888,0,0,0-.973-.1c-.768,0-1.536.307-1.536,1.331,0,1.177,1.28,1.075,1.28,1.536,0,.307-.358.358-.614.358a3.347,3.347,0,0,1-.921-.154l-.154.921C135.251,230.495,135.507,230.6,136.377,230.6Z",
    transform: "translate(-127.471 -225.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M430.118,214.4l-.2,1.382a1.419,1.419,0,0,0-.973-.512c-.921,0-1.74,1.126-1.74,2.457,0,.819.409,1.689,1.28,1.689a1.366,1.366,0,0,0,.973-.41l-.051.358h1.024l.768-4.914Zm-.461,2.713c0,.563-.256,1.28-.819,1.28-.358,0-.563-.307-.563-.819,0-.819.358-1.331.819-1.331C429.452,216.243,429.657,216.5,429.657,217.113Z",
    transform: "translate(-400.787 -214.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M15.373,219.314l.614-3.685.1,3.685h.717l1.331-3.685-.563,3.685h1.075l.819-4.914H17.778l-1.024,3.02L16.7,214.4H15.219l-.819,4.914Z",
    transform: "translate(-14.4 -214.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M261.126,232.793c.307-1.689.358-3.071,1.075-2.815a4.016,4.016,0,0,1,.358-1.177h-.2c-.461,0-.819.614-.819.614l.1-.563h-.973L260,232.844h1.126Z",
    transform: "translate(-244.286 -227.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M348.345,227.2a3.625,3.625,0,0,0-1.228.2l-.154.87a3.025,3.025,0,0,1,1.126-.2c.358,0,.665.051.665.358,0,.2-.051.256-.051.256h-.461c-.87,0-1.843.358-1.843,1.536,0,.921.614,1.126.973,1.126a1.538,1.538,0,0,0,1.075-.461l-.051.41h.921l.41-2.815A1.2,1.2,0,0,0,348.345,227.2Zm.256,2.3c0,.154-.1.973-.717.973a.4.4,0,0,1-.409-.41c0-.256.154-.614.921-.614C348.55,229.5,348.55,229.5,348.6,229.5Z",
    transform: "translate(-325.157 -226.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M395.526,232.793c.307-1.689.358-3.071,1.075-2.815a4.02,4.02,0,0,1,.358-1.177h-.2c-.461,0-.819.614-.819.614l.1-.563h-.973l-.665,3.993h1.126Z",
    transform: "translate(-370.086 -227.776)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(0.921 7.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M180,223.788a.768.768,0,0,0,.819.87,1.949,1.949,0,0,0,.768-.154l.154-.87a2.218,2.218,0,0,1-.256.051c-.358,0-.41-.2-.358-.307l.307-1.792H182l.154-.973h-.512l.1-.614",
    transform: "translate(-169.404 -219.539)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M218.4,231.009c0,1.433.461,1.792,1.28,1.792a2.657,2.657,0,0,0,1.075-.154l.2-.973a3.068,3.068,0,0,1-1.075.256c-1.126,0-.921-.819-.921-.819h2.1a6.637,6.637,0,0,0,.154-.921,1.387,1.387,0,0,0-1.484-1.484C218.656,228.6,218.4,229.729,218.4,231.009Zm1.28-1.484c.563,0,.665.665.665.717h-1.331C219.014,230.19,219.117,229.524,219.68,229.524Z",
    transform: "translate(-205.347 -227.681)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M306.3,217.765l.2-1.126a2.516,2.516,0,0,1-.87.256c-.717,0-1.024-.563-1.024-1.177,0-1.228.614-1.894,1.331-1.894a1.709,1.709,0,0,1,.921.307l.154-1.075a3.6,3.6,0,0,0-1.177-.256c-1.177,0-1.843,1.024-1.843,2.969,0,1.28.1,2.15,1.331,2.15A4.593,4.593,0,0,0,306.3,217.765Z",
    transform: "translate(-285.47 -212.8)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M86.963,229.824a3.026,3.026,0,0,1,1.126-.2c.358,0,.665.051.665.358,0,.2-.051.256-.051.256h-.461c-.87,0-1.843.358-1.843,1.536,0,.921.614,1.126.973,1.126a1.538,1.538,0,0,0,1.075-.461l-.051.41h.921l.41-2.815c0-1.177-1.024-1.228-1.433-1.228m.768,2.2a1.676,1.676,0,0,1-1.228.973.4.4,0,0,1-.409-.409c0-.256.154-.614.921-.614A4.183,4.183,0,0,0,89.062,231Z",
    transform: "translate(-81.793 -227.776)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M136,230.495a4.332,4.332,0,0,0,1.177.1,1.312,1.312,0,0,0,1.536-1.331c0-1.28-1.229-1.024-1.229-1.536,0-.256.2-.358.563-.358.154,0,.717.051.717.051l.154-.921a3.888,3.888,0,0,0-.973-.1c-.768,0-1.024.307-1.024,1.331,0,1.177.768,1.075.768,1.536,0,.307-.358.358-.614.358",
    transform: "translate(-128.22 -225.53)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M437.347,216.531a1.419,1.419,0,0,0-.973-.512c-.921,0-1.229,1.126-1.229,2.457,0,.819-.1,1.689.768,1.689a1.367,1.367,0,0,0,.973-.409l-.051.358h1.024l.768-4.914m-1.331,2.662c0,.563-.461,1.28-1.024,1.28-.358,0-.563-.307-.563-.819,0-.819.358-1.331.819-1.331A.782.782,0,0,1,437.3,217.862Z",
    transform: "translate(-408.221 -215.046)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M15.373,219.314l.614-3.685.1,3.685h.717l1.331-3.685-.563,3.685h1.075l.819-4.914h-1.28l-1.433,3.02L16.7,214.4H16.14l-1.74,4.914Z",
    transform: "translate(-14.4 -214.298)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M260.8,232.793h1.075c.307-1.689.358-3.071,1.075-2.815a4.016,4.016,0,0,1,.358-1.177h-.2c-.461,0-.819.614-.819.614l.1-.563",
    transform: "translate(-245.034 -227.776)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M346.963,229.824a3.026,3.026,0,0,1,1.126-.2c.358,0,.665.051.665.358,0,.2-.051.256-.051.256h-.461c-.87,0-1.843.358-1.843,1.536,0,.921.614,1.126.973,1.126a1.538,1.538,0,0,0,1.075-.461l-.051.41h.921l.409-2.815c0-1.177-1.024-1.228-1.433-1.228m.768,2.2a1.676,1.676,0,0,1-1.228.973.4.4,0,0,1-.41-.409c0-.256.154-.614.921-.614A4.5,4.5,0,0,0,349.062,231Z",
    transform: "translate(-325.157 -227.776)",
    fill: "#dce5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M395.2,232.793h1.075c.307-1.689.358-3.071,1.075-2.815a4.018,4.018,0,0,1,.358-1.177h-.2c-.461,0-.819.614-.819.614l.1-.563",
    transform: "translate(-370.835 -227.776)",
    fill: "#dce5e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.195fb927843313afca13a6bfd2b2af38.svg";
export { ForwardRef as ReactComponent };